import { CoralProductMeta, ProductMeta } from '@websrc/Basket/useProductMeta'

import { priceStringToNumber } from './formatting'
import { isUnderTest } from './isUnderTest'

export function trackLink(
  details: {
    name: string
    events?: string
    products?: string
  },
  type: 'e' | 'o' | 'd' = 'o'
) {
  if (isUnderTest()) return
  let identifier = 'custom-link'

  if (type === 'e') {
    identifier = 'external-link'
  } else if (type === 'd') {
    identifier = 'download-link'
  }

  ;(window as any)._satellite?.track?.(identifier, details)
}

export function trackEvent(identifier: string, details?: object) {
  if (isUnderTest()) return
  ;(window as any)._satellite?.track?.(identifier, details)
}

export function createTrackingProduct(
  productMeta: ProductMeta | CoralProductMeta,
  quantity: number,
  price: string
) {
  return {
    id: `${productMeta.product_number}`,
    name: productMeta.name,
    type: 'type' in productMeta ? productMeta.type?.toLowerCase() : undefined,
    price: `${(quantity * priceStringToNumber(price)).toFixed(2)}`,
    quantity: `${quantity}`,
    in_stock: productMeta.product_status !== 'E2' ? 'yes' : 'no',
    grade: 'grade' in productMeta ? productMeta.grade ?? '' : '',
    student_count: 'number_of_students' in productMeta ? `${productMeta.number_of_students}` : '',
  }
}

export function createTrackingCoralProduct(
  coralProductMeta: CoralProductMeta,
  quantity: number,
  price: string
) {
  return {
    id: `${coralProductMeta.product_number}`,
    name: coralProductMeta.name,
    price: `${(quantity * priceStringToNumber(price)).toFixed(2)}`,
    quantity: `${quantity}`,
    in_stock: coralProductMeta.product_status !== 'E2' ? 'yes' : 'no',
  }
}
